import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Store {
  id: number;
  name: string;
  code: string;
  description?: string;
  is_active?: boolean;
}

interface StoreState {
  // Available stores for the user
  availableStores: Store[];
  
  // Currently selected store
  currentStore: Store | null;
  
  // Default store ID
        defaultStoreId: number | null;
  
  // Loading states
  isLoading: boolean;
  error: string | null;
}

interface StoreActions {
  // Set available stores
  setAvailableStores: (stores: Store[]) => void;
  
  // Set current store
  setCurrentStore: (store: Store) => void;
  
  // Set default store
  setDefaultStore: (storeId: number) => void;
  
  // Switch to a different store
  switchStore: (storeId: number) => void;
  
        // Initialize store with default
      initializeStore: (stores: Store[], defaultStoreId?: number) => void;
  
  // Clear store data
  clearStore: () => void;
  
  // Set loading state
  setLoading: (loading: boolean) => void;
  
  // Set error
  setError: (error: string | null) => void;
}

type StoreStore = StoreState & StoreActions;

export const useStoreStore = create<StoreStore>()(
  persist(
    (set, get) => ({
      // Initial state
      availableStores: [],
      currentStore: null,
      defaultStoreId: null,
      isLoading: false,
      error: null,

      // Actions
      setAvailableStores: (stores) => set({ availableStores: stores }),
      
      setCurrentStore: (store) => set({ currentStore: store }),
      
      setDefaultStore: (storeId: number) => set({ defaultStoreId: storeId }),
      
      switchStore: (storeId: number) => {
        const { availableStores } = get();
        const store = availableStores.find(s => s.id === storeId);
        if (store) {
          set({ currentStore: store });
        }
      },
      
      initializeStore: (stores, defaultStoreId) => {
        const currentDefaultStoreId = defaultStoreId || get().defaultStoreId;
        const defaultStore = stores.find(s => s.id === currentDefaultStoreId) || stores[0];
        

        
        set({
          availableStores: stores,
          currentStore: defaultStore,
          defaultStoreId: defaultStore?.id || null
        });
      },
      
      clearStore: () => set({
        availableStores: [],
        currentStore: null,
        defaultStoreId: null,
        error: null
      }),
      
      setLoading: (loading) => set({ isLoading: loading }),
      
      setError: (error) => set({ error })
    }),
    {
      name: 'store-storage',
      partialize: (state) => ({
        currentStore: state.currentStore,
        defaultStoreId: state.defaultStoreId
      })
    }
  )
);
